import { animated, useSpring } from "@react-spring/web";
import Color from "color";
import { DancerRole } from "../interfaces/Choreography";

import { PreviewDancerProps } from "../interfaces/PatternView";
import {
  getFontColor,
  getPositionAfterPatterRotation,
  getStrokeFromColor,
  lumDiff,
  lumDiffAlt,
  customLighten,
  diffToLighten,
} from "../services/VisServices";

function PreviewDancer(props: PreviewDancerProps) {
  const colorLightenFactor = 0.4;
  let color: Color = determineColor();
  let strokeColor = props.colorCodedCouples
    ? getStrokeFromColor(color.hex(), 0.2)
    : color.hex();

  function determineColor(): Color {
    let colorToReturn: Color;
    if (
      props.danceCouple.position[0].x === props.danceCouple.position[1].x &&
      props.danceCouple.position[0].y === props.danceCouple.position[1].y
    ) {
      colorToReturn = Color(String(props.coupleColor));
    } else {
      switch (props.role) {
        case DancerRole.Gentleman:
          colorToReturn = Color(String(props.gentlemanColor));
          break;
        case DancerRole.Lady:
          colorToReturn = Color(String(props.ladyColor));
          break;
      }
    }
    const diff = lumDiffAlt(Color("#FFFFFF"), colorToReturn);
    colorToReturn = customLighten(colorToReturn, diffToLighten(diff));

    return colorToReturn;
  }

  function getTransform() {
    return `translate(${props.xScale(
      getPositionAfterPatterRotation(props.pos, props.patternRotation).x
    )}, ${props.yScale(
      getPositionAfterPatterRotation(props.pos, props.patternRotation).y
    )})`;
  }

  function clickThisPreviewDancer(e: any) {
    if (props.showTransitions) {
      props.setSelectedDancerForTransitions(props.id);
    }
    e.stopPropagation();
  }

  function getLabel(): JSX.Element {
    const roleIcon = props.danceCouple.joint
      ? "C"
      : props.role === DancerRole.Gentleman
      ? "G"
      : "L";

    if (props.colorCodedCouples) {
      return (
        <animated.text
          key={props.id}
          textAnchor="middle"
          alignmentBaseline="middle"
          fill={getFontColor(color.hex())}
          className="unselectable-text"
          style={{
            fontSize: 0.028 * props.dms.boundedWidth,
            transform: "translateY(" + props.dms.boundedWidth / 200 + "px)",
          }}
        >
          {roleIcon}
        </animated.text>
      );
    }

    return (
      <animated.text
        key={props.id}
        textAnchor="middle"
        alignmentBaseline="middle"
        fill="white"
        className="unselectable-text"
        style={{
          fontSize: 0.028 * props.dms.boundedWidth,
          transform: "translateY(" + props.dms.boundedWidth / 200 + "px)",
        }}
      >
        {props.danceCouple.id}
      </animated.text>
    );
  }

  return (
    <animated.g
      key={props.id}
      transform={getTransform() as string}
      style={{
        cursor: "pointer",
      }}
      visibility={!props.showTransitions ? "hidden" : "visible"}
      onClick={clickThisPreviewDancer}
    >
      <animated.circle
        fill={color.hex()}
        stroke={strokeColor}
        r={0.015 * props.dms.boundedWidth}
      />
      {getLabel()}
    </animated.g>
  );
}

export default PreviewDancer;
